import React from 'react';
import type { HeadingProps } from '@makemydeal/dr-ui-bricks-types';
import { StyledHeading } from './Heading.style';
import { HEADING_ELEMENT } from '../typographyScale/constants';

const Heading: React.FC<HeadingProps> = ({ level = 1, weight = 'semibold', as, color, children, ...rest }) => (
    <StyledHeading as={as ?? HEADING_ELEMENT[level]} $level={level} $weight={weight} $color={color} {...rest}>
        {children}
    </StyledHeading>
);

export default Heading;
